/*jshint esversion: 9 */
import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { observer } from "mobx-react";
import { withStyles } from '@material-ui/core/styles';
import SelectionOfOrderManagement from './SelectionOfOrderManagement';
import TableOfOrderManagement from './TableOfOrderManagement';
import Typography from '@material-ui/core/Typography';
import store from "../../../../components/stores/Store";

const styles = {
  root: {
    '& .MuiTextField-root': {
      margin: '10px',
      width: '25ch',
    },
  },
};
class OrderManagementInner extends Component {
  constructor() {
    super();
    this.state = {
      login: true,
    };
  }

  async componentDidMount() {
    document.title = "交易记录管理";
  }

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <Typography variant="h5" gutterBottom>
          交易记录管理
        </Typography>
        <SelectionOfOrderManagement />
        <TableOfOrderManagement />
      </div>
    );
  }
}

const OrderManagement = observer(OrderManagementInner);

OrderManagement.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(OrderManagement);

// for mobile template
// https://material-ui.com/store/previews/devias-kit/
// https://material-ui.com/store/previews/paperbase/
// https://demos.creative-tim.com/material-kit-react/#/